// extracted by mini-css-extract-plugin
module.exports = {"pHeroContent__text":"l_J","cGatsbyBackground":"l_b","pHeroContent":"l_K","pHeroContent__inner":"l_L","pHeroContent__title":"l_M","pHeroContent__sns":"l_N","animationMarquee":"l_d"};